<template>
  <div class="tables-edit-outer">
    <div v-if="!isEditting" class="tables-edit-con">
      <template v-if="params.column.tooltip">
        <Tooltip transfer :content="value" :theme="params.column.tooltipTheme ? params.column.tooltipTheme : 'dark'" :disabled="!showTooltip" :max-width="params.column.tooltipMaxWidth ? params.column.tooltipMaxWidth : 300" class="ivu-table-cell-tooltip value-con">
          <span ref="content" @mouseenter="handleTooltipIn" class="ivu-table-cell-tooltip-content">{{ value }}</span>
        </Tooltip>
      </template>
      <span v-else class="value-con">{{value}}</span>
      <Button v-if="editable" @click="startEdit" class="tables-edit-btn" style="padding: 2px 4px;" type="text"><Icon type="md-create"></Icon></Button>
    </div>
    <div v-else class="tables-editting-con">
      <Input :value="value" @input="handleInput" class="tables-edit-input"/>
      <Button @click="saveEdit" style="padding: 6px 4px;" type="text"><Icon type="md-checkmark"></Icon></Button>
      <Button @click="canceltEdit" style="padding: 6px 4px;" type="text"><Icon type="md-close"></Icon></Button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TablesEdit',
  props: {
    value: [String, Number],
    rowKey: [String, Number],
    edittingCellId: String,
    params: Object,
    editable: Boolean,
  },
  data(){
    return{
      showTooltip: false
    }
  },
  computed: {
    isEditting () {
      //return this.edittingCellId === `editting-${this.params.index}-${this.params.column.key}`
      return this.edittingCellId === `editting-${this.rowKey}-${this.params.column.key}`
    }
  },
  methods: {
    handleInput (val) {
      this.$emit('input', val)
    },
    startEdit () {
      //this.$emit('on-start-edit', this.params)
      this.$emit('on-start-edit', this.params,this.rowKey)
    },
    saveEdit () {
      this.$emit('on-save-edit', this.params)
    },
    canceltEdit () {
      this.$emit('on-cancel-edit', this.params)
    },
    handleTooltipIn () {
      const $content = this.$refs.content;
      let range = document.createRange();
      range.setStart($content, 0);
      range.setEnd($content, $content.childNodes.length);
      const rangeWidth = range.getBoundingClientRect().width;
      this.showTooltip = rangeWidth > $content.offsetWidth;
      range = null;
    },
  }
}
</script>

<style lang="less">
.tables-edit-outer{
  height: 100%;
  .tables-edit-con{
    position: relative;
    height: 100%;
    .value-con{
      vertical-align: middle;
      display: inherit;
      width: 100%;
    }
    .tables-edit-btn{
      position: absolute;
      right: 10px;
      top: 0;
      display: none;
    }
    &:hover{
      .tables-edit-btn{
        display: inline-block;
      }
    }
  }
  .tables-editting-con{
    .tables-edit-input{
      width: ~"calc(100% - 60px)";
    }
  }
}
.show-edit {
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/components/tables/edit.vue